import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Refresh = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M18.885 9.014a.5.5 0 1 0 .916-.4l-.458.2zm-14.712-.4a.5.5 0 1 0 .917.4l-.459-.2zm12.638-.648a.5.5 0 1 0-.447.894l.223-.447zm2.986 2.051-.224.448a.5.5 0 0 0 .683-.25zm1.663-2.61a.5.5 0 0 0-.92-.395l.46.197zM5.115 15.031a.5.5 0 0 0-.916.4l.458-.2zm14.712.4a.5.5 0 0 0-.917-.4l.459.2zm-12.638.649a.5.5 0 1 0 .447-.894l-.223.447zm-2.986-2.052.224-.447a.5.5 0 0 0-.683.25zM2.54 16.64a.5.5 0 1 0 .92.394L3 16.837zM11.987 4v.5a7.53 7.53 0 0 1 6.898 4.514l.458-.2.458-.2A8.53 8.53 0 0 0 11.987 3.5zM4.631 8.814l.459.2A7.53 7.53 0 0 1 11.987 4.5v-1a8.53 8.53 0 0 0-7.814 5.114zm11.956-.401-.223.447 3.209 1.605.224-.448.223-.447-3.21-1.604zm3.21 1.604.46.197 1.203-2.808L21 7.21l-.46-.197-1.203 2.808zm-7.784 10.03v-.5a7.53 7.53 0 0 1-6.898-4.515l-.458.2-.458.2a8.53 8.53 0 0 0 7.814 5.115zm7.356-4.815-.459-.2a7.53 7.53 0 0 1-6.897 4.515v1a8.53 8.53 0 0 0 7.814-5.114zm-11.956.402.223-.447-3.209-1.605-.224.447-.223.447 3.21 1.605zm-3.21-1.605-.46-.197L2.54 16.64l.46.197.46.197 1.203-2.808z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Refresh) as SvgIcon;
export { ForwardRef as ReactComponent };
